import React from 'react';

export default function Key({ className }) {
  return (
    <div className={`siteplan__keys${className ? ` ${className}` : ''}`}>
      <ul className="siteplan__key-list">
        <li className="siteplan__key-item">
          <p className="siteplan__key">
            <span className="siteplan__key-circle siteplan__key-circle--available" />
            <span className="siteplan__key-label">Available</span>
          </p>
        </li>
        <li className="siteplan__key-item">
          <p className="siteplan__key">
            <span className="siteplan__key-circle siteplan__key-circle--soon" />
            <span className="siteplan__key-label">Coming soon</span>
          </p>
        </li>
        <li className="siteplan__key-item">
          <p className="siteplan__key">
            <span className="siteplan__key-circle siteplan__key-circle--sold" />
            <span className="siteplan__key-label">Sold</span>
          </p>
        </li>
      </ul>
    </div>
  );
}
